import {
  createRouter,
  createWebHistory,
  RouteLocationNormalized,
  NavigationGuardNext,
  RouteLocationNormalizedLoaded,
  RouteRecordRaw
} from 'vue-router'
import { Toast } from '@hala/ui'
import { setPageInfo } from 'kwsdk'
import { setLoading, setShare, allowRefreshOrShare } from '@/utils'

const includeList = [
  'interview_arrange',
  'candidate',
  'talent',
  'shareTalent',
  'recruitment',
  'postDetail',
  'resume',
  'interview',
  'resumeEdit',
  'offer'
]

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/recruitment'
  },
  {
    path: '/recruitment',
    name: 'recruitment',
    component: () => import('../views/Recruitment/Recruitment.vue'),
    meta: {
      // keepAlive: true //若想页面有缓存 除了设置keepAlive=true 还需要设置组件名称和这里的name保持一致
      title: '加入孩子王',
      pageId: 'recruitment'
    }
  },
  {
    path: '/interviewer',
    name: 'interviewer',
    component: () => import('../views/interviewer/index.vue'),
    meta: {
      title: '星探',
      pageId: 'interviewer'
    }
  },
  {
    path: '/interviewer/detail/:id',
    name: 'detail',
    component: () => import('../views/interviewer/detail/index.vue'),
    meta: {
      title: '详情',
      pageId: 'interviewer'
    }
  },
  {
    path: '/interviewer/recommend',
    name: 'recommend',
    component: () => import('../views/interviewer/detail/Recommend.vue'),
    meta: {
      title: '推荐职位',
      pageId: 'recommend'
    }
  },
  {
    path: '/interviewer/summary-detail/:id',
    name: 'summary',
    component: () => import('../views/interviewer/detail/SummaryDetail.vue'),
    meta: {
      title: '面试反馈',
      pageId: 'summary'
    }
  },
  {
    path: '/interviewer/summary-edite',
    name: 'summary-edite',
    component: () => import('../views/interviewer/detail/SummaryEdite.vue'),
    meta: {
      title: '面试反馈',
      pageId: 'summary-edite'
    }
  },
  {
    path: '/interviewer/candidate',
    name: 'candidate',
    component: () => import('../views/interviewer/list/candidate.vue'),
    meta: {
      title: '候选人筛选',
      pageId: 'candidate',
      keepAlive: true
    }
  },
  {
    path: '/interviewer/talent',
    name: 'talent',
    component: () => import('../views/interviewer/list/talent.vue'),
    meta: {
      title: '达人',
      pageId: 'talent'
    }
  },
  {
    path: '/interviewer/shareTalent',
    name: 'shareTalent',
    component: () => import('../views/interviewer/list/shareTalent.vue'),
    meta: {
      title: '共享人才库',
      pageId: 'shareTalent'
    }
  },
  {
    path: '/interviewer/interview',
    name: 'interview_arrange',
    component: () => import('../views/interviewer/list/Interview.vue'),
    meta: {
      title: '面试安排',
      pageId: 'interview_arrange',
      keepAlive: true
    }
  },
  {
    path: '/resume',
    name: 'resume',
    component: () => import('../views/Recruitment/resume.vue'),
    meta: {
      title: '我的简历-加入孩子王',
      pageId: 'resume'
    }
  },
  {
    path: '/resumeEdit',
    name: 'resumeEdit',
    component: () => import('../views/Recruitment/resumeEdit.vue'),
    meta: {
      title: '我的简历-加入孩子王',
      pageId: 'resumeEdit'
    }
  },
  {
    path: '/application-record',
    name: 'application-record',
    component: () => import('../views/Recruitment/applicationRecord.vue'),
    meta: {
      title: '应聘记录-加入孩子王',
      pageId: 'application-record'
    }
  },
  {
    path: '/postDetail',
    name: 'postDetail',
    component: () => import('../views/Recruitment/postDetail.vue'),
    meta: {
      title: '职位信息',
      pageId: 'postDetail'
    }
  },
  {
    path: '/interview',
    name: 'interview',
    component: () => import('../views/Recruitment/interview.vue'),
    meta: {
      title: '我的面试-加入孩子王',
      pageId: 'interview'
    }
  },
  {
    path: '/interviewDetail',
    name: 'interviewDetail',
    component: () => import('../views/Recruitment/interviewDetail.vue'),
    meta: {
      title: '我的面试-加入孩子王',
      pageId: 'interviewDetail'
    }
  },
  {
    path: '/offer',
    name: 'offer',
    component: () => import('../views/Recruitment/offer.vue'),
    meta: {
      title: '我的offer-加入孩子王',
      background: '#F4F5FA',
      pageId: 'offer'
    }
  },
  {
    path: '/videoUpload',
    name: 'videoUpload',
    component: () => import('../views/Recruitment/videoUpload.vue'),
    meta: {
      title: '我的视频-加入孩子王',
      background: '#F4F5FA',
      pageId: 'videoUpload'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login/index.vue'),
    meta: {
      // keepAlive: true //若想页面有缓存 除了设置keepAlive=true 还需要设置组件名称和这里的name保持一致
      title: '登录',
      pageId: 'xxxxxx'
    }
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('../views/Recruitment/agreement.vue'),
    meta: {
      title: '用户协议',
      pageId: 'xxxxxx'
    }
  },
  {
    path: '/privacyProtection',
    name: 'privacyProtection',
    component: () => import('../views/Recruitment/privacyProtection.vue'),
    meta: {
      title: '隐私政策',
      pageId: 'xxxxxx'
    }
  },
  {
    path: '/:nofound(.*)',
    name: '404',
    component: () => import('../views/NotFound.vue')
  },
  {
    path: '/signIn',
    name: 'signIn',
    component: () => import('../views/signIn.vue'),
    meta: {
      title: '面试签到列表'
    }
  },
  {
    path: '/signSucc',
    name: 'signSucc',
    component: () => import('../views/signSucc.vue'),
    meta: {
      title: '签到成功'
    }
  },
  {
    path: '/acceptSucc',
    name: 'acceptSucc',
    component: () => import('../views/Recruitment/acceptSucc.vue'),
    meta: {
      title: '接受面试成功'
    }
  },
  {
    path: '/applyForm',
    name: 'applyForm',
    component: () => import('../views/applyForm.vue'),
    meta: {
      title: '填写应聘登记表'
    }
  },
  {
    path: '/interviewComment',
    name: 'interviewComment',
    component: () => import('../views/interviewComment.vue'),
    meta: {
      title: '面试满意度调研'
    }
  }
]

const scrollBehavior = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalizedLoaded,
  savedPosition: any
) => {
  if (!from.name) {
    // 没有来源路由，刷新页面
    // 为防止数据没有加载但是吸顶已经上去了，不返回原先的滚动条位置
    return {
      left: 0,
      top: 0
    }
  }
  if (savedPosition && to.meta.keepAlive) {
    return savedPosition
  } else {
    if (to.hash) {
      return {
        el: to.hash
      }
    } else {
      return {
        left: 0,
        top: 0
      }
    }
  }
}

const router = createRouter({
  history: createWebHistory('rkhy/rkhy-recruitment'),
  routes,
  scrollBehavior
})
router.beforeEach((to, from, next) => {
  Toast.kwloading()
  next()
})

// router.beforeEach(
//   (
//     to: RouteLocationNormalized,
//     from: RouteLocationNormalized,
//     next: NavigationGuardNext
//   ) => {
//     if (Object.keys(to.query).indexOf('_debug') > -1) {
//       import('vconsole').then(v => {
//         new v.default()
//       })
//     }
//     let canShare = true
//     let canRefresh = true
//     if (to && to.query) {
//       const query = to.query
//       if (query.cmd === 'share' && query.sharetype === '0') {
//         canShare = false
//       }
//       if (query.refresh === 'no') {
//         canRefresh = false
//       }
//     }
//     allowRefreshOrShare(canRefresh, canShare)
//     setLoading()
//     next()
//   }
// )

router.afterEach(to => {
  setShare()
  setLoading(false)
  // 设置页面标题和禁用app分享
  const { meta } = to
  const { title, pageId } = meta || {}
  if (title) {
    setPageInfo({
      title: title,
      refresh: pageId ? includeList.includes(pageId as string) : false,
      share: true
    })
  }
})

export default router
